var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('doc-title',{attrs:{"text":"Suche"}}),_c('h1',[_vm._v(" Suche ")]),_c('hr'),_c('list',{attrs:{"resource":"posts/search","params":{ q: _vm.$route.query.q }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }